import React, { FC } from "react";
import {
  Control,
  UseFormRegister,
  UseFormSetValue,
  UseFormSetError,
  UseFormClearErrors,
  UseFieldArrayRemove,
} from "react-hook-form";
import RemoveItem from "app/components/common/buttons/RemoveItem";
import InputField from "app/components/common/inputs/InputField";
import FormGroup from "app/components/common/inputs/FormGroup";
import AutocompleteLocations from "app/components/common/AutocompleteLocations";

interface FieldItem {
  id: string;
  dbId?: string;
}
interface Props {
  control: Control<any>;
  errors: any;
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
  setError: UseFormSetError<any>;
  clearErrors: UseFormClearErrors<any>;
  fields: FieldItem[];
  deleteItem: any;
  realState: string;
  remove: UseFieldArrayRemove;
  applicantID: string;
  deleteIsPending?: boolean;
}

const DynamicRealEstate: FC<Props> = ({
  control,
  errors,
  register,
  setValue,
  setError,
  clearErrors,
  fields,
  realState,
  deleteItem,
  applicantID,
  remove,
  deleteIsPending = false,
}) => {
  const getErrorMessage = (fieldName: string) => {
    const fieldNames = fieldName.split(".");
    return fieldNames.reduce((acc, key) => acc && acc[key], errors);
  };
  return (
    <>
      {fields.map((field, index) => {
        const basePath = `${realState}.${index}`;
        return (
          <>
            <FormGroup key={field.id} className="relative">
              <AutocompleteLocations
                FieldName={`${basePath}.detail`}
                placeholder="2464 Royal Ln. Mesa..."
                register={register}
                setValue={setValue}
                setError={setError}
                label="Property address"
                required={true}
                className="flex-1"
                error={getErrorMessage(`${basePath}.detail`)?.message as string}
                // stateFieldName="employerAddress.state"
                // postCodeFieldName="employerAddress.postCode"
                clearErrors={clearErrors}
              />
              <InputField
                label={`Estimated property value`}
                name={`${basePath}.value`}
                control={control}
                type="number"
                required={true}
                placeholder="$18,000"
                //   error={
                //     errors.realState?.[index]?.value?.message as
                //       | string
                //       | undefined
                //   }
                error={getErrorMessage(`${basePath}.value`)?.message as string}
                className="flex-1"
                rules={{
                  min: {
                    value: 1,
                    message: "value must be greater than 0",
                  },
                }}
              />
              {index > 0 && (
                <RemoveItem
                  className="absolute right-0"
                  disabled={deleteIsPending}
                  onClick={() => {
                    if (field?.dbId) {
                      deleteItem(
                        `/asset-liability/${applicantID}/realstate/${field?.dbId}`,
                        {
                          onSuccess: () => {
                            remove(index);
                          },
                        }
                      );
                    } else {
                      remove(index);
                    }
                  }}
                />
              )}
            </FormGroup>
          </>
        );
      })}
    </>
  );
};

export default DynamicRealEstate;
